import React, { FC, SVGProps } from 'react';

interface FacebookProps extends SVGProps<SVGSVGElement> {
  backgroundColor?: string;
}

export const Facebook: FC<FacebookProps> = ({
  backgroundColor,
  fill,
  ...props
}) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={backgroundColor || '#26313B'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0398 24.8928L29.6515 20.9001H25.8221V18.3097C25.8221 17.2183 26.3561 16.1522 28.0727 16.1522H29.8147V12.7538C29.8147 12.7538 28.234 12.4839 26.7231 12.4839C23.5695 12.4839 21.5072 14.3948 21.5072 17.8572V20.9003H18V24.8929H21.5072V34.5424H25.8221V24.8929L29.0398 24.8928Z"
      fill={fill || 'white'}
    />
  </svg>
);
